<template>
    <ModalBase :show-modal="showModal" @close-modal="close" :short="true" :auto-h="true" :narrow="true" class="modal-size">
        <template v-slot:titlebar>
            <TitleBar variant-class="title-modal">
                <template v-slot:title>
                    <span v-translate>Copy entry</span>
                </template>
            </TitleBar>
        </template>

        <template v-slot:maincontent>
            <div class="copy-hour-modal-content">
                <b-form>
                    <b-form-row>
                        <b-form-group id="input-group-1"  label-for="input-1">
                            <template slot="label">
                                <span v-translate>Date</span>
                            </template>
                            <b-input-group>
                                <b-form-datepicker 
                                    v-model="newStartDate" 
                                    :required="true" 
                                    :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }" 
                                    id="input-1" />
                            </b-input-group>
                        </b-form-group>
                    </b-form-row>
                    <b-form-row>
                        <b-form-group id="input-group-2"  label-for="input-2">
                            <template slot="label">
                                <span v-translate>Start time</span>
                            </template>
                            <b-input-group>
                                <TimePicker 
                                    v-model="newStartTime" 
                                    data-type="date" 
                                    period="start" 
                                    class="timepicker-style time-picker" 
                                    id="input-2"/>
                            </b-input-group>
                        </b-form-group>
                    </b-form-row>
                </b-form>
            </div>
        </template>

        <template v-slot:actions>
            <GekkoButton @click="copyHour()" :text="$gettext('Ok')" class="pull-right" />
        </template>
    </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase.vue";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import TimePicker from "@/components/hours/TimePicker";

export default {
    name: "CopyHourModal",
    components: { ModalBase, TitleBar, TimePicker, GekkoButton },
    props: {
        hour: {
            type: Object,
            default() {return {}}
        }
    },
    watch: {
        hour(val) {
            this.newStartDate = new Date();
            this.newStartTime = val.start;
        }
    },
    data() {
        return {
            showModal: false,
            newStartDate: null,
            newStartTime: null
        }
    },
    methods: {
        close() {
            this.showModal = false;
        },
        copyHour() {
            if (this.$store.getters['getIsPremium']) {
                let newHour = JSON.parse(JSON.stringify(this.hour));
            
                newHour.start = this.createDateTimeObject(this.newStartDate, this.newStartTime);
                newHour.end = new Date(newHour.start);
                newHour.end.setHours(newHour.end.getHours() + newHour.amount_hours);
                newHour.end.setMinutes(newHour.end.getMinutes() + newHour.amount_minutes);

                this.$emit("copyHour", newHour);
                this.close();
            } else {
                this.$store.commit('togglePremiumModal', 'web_hours_copy');
            }
        },
        createDateTimeObject(date, time) {
            let newDateObj = new Date(date);
            newDateObj.setHours(time.getHours());
            newDateObj.setMinutes(time.getMinutes());
            return newDateObj;
        }
    }
}
</script>

<style lang="scss" scoped>
.copy-hour-modal-content {
    margin-left: 8px;
}

.modal-size {
	.gk-modal {
		max-width: 325px;
	}
}
</style>